"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _react = _interopRequireDefault(require("react"));

var _theme = require("../theme");

var _marginPadding = require("../Space/margin-padding");

var _core = require("@emotion/core");

var getStyles = function getStyles(_ref) {
  var theme = _ref.theme,
      boxSizing = _ref.boxSizing,
      top = _ref.top,
      left = _ref.left,
      right = _ref.right,
      bottom = _ref.bottom,
      width = _ref.width,
      height = _ref.height,
      minWidth = _ref.minWidth,
      minHeight = _ref.minHeight,
      maxWidth = _ref.maxWidth,
      maxHeight = _ref.maxHeight,
      backgroundColor = _ref.backgroundColor,
      color = _ref.color,
      border = _ref.border,
      borderTop = _ref.borderTop,
      borderLeft = _ref.borderLeft,
      borderRight = _ref.borderRight,
      borderBottom = _ref.borderBottom,
      borderRadius = _ref.borderRadius,
      borderColor = _ref.borderColor,
      display = _ref.display,
      position = _ref.position,
      order = _ref.order,
      lineHeight = _ref.lineHeight,
      textAlign = _ref.textAlign,
      verticalAlign = _ref.verticalAlign,
      flex = _ref.flex,
      flexWrap = _ref.flexWrap,
      flexDirection = _ref.flexDirection,
      alignItems = _ref.alignItems,
      justifyContent = _ref.justifyContent,
      alignSelf = _ref.alignSelf,
      overflow = _ref.overflow,
      overflowX = _ref.overflowX,
      overflowY = _ref.overflowY,
      tabIndex = _ref.tabIndex,
      hidden = _ref.hidden,
      center = _ref.center;
  var space = theme.space,
      palette = theme.palette,
      radii = theme.radii;
  return {
    alignSelf: alignSelf,
    border: border,
    boxSizing: boxSizing,
    borderBottom: borderBottom,
    borderLeft: borderLeft,
    borderRight: borderRight,
    borderTop: borderTop,
    flex: flex,
    flexDirection: flexDirection,
    flexWrap: flexWrap,
    height: height,
    hidden: hidden,
    lineHeight: lineHeight,
    maxHeight: maxHeight,
    maxWidth: maxWidth,
    minHeight: minHeight,
    minWidth: minWidth,
    order: order,
    overflow: overflow,
    overflowX: overflowX,
    overflowY: overflowY,
    position: position,
    textAlign: textAlign,
    tabIndex: tabIndex,
    verticalAlign: verticalAlign,
    width: width,
    top: top && space[top],
    left: left && space[left],
    right: right && space[right],
    bottom: bottom && space[bottom],
    color: color && palette[color],
    backgroundColor: backgroundColor && palette[backgroundColor],
    borderRadius: borderRadius && radii[borderRadius],
    borderColor: borderColor && palette[borderColor],
    display: center ? display || 'flex' : display,
    alignItems: center ? alignItems || 'center' : alignItems,
    justifyContent: center ? justifyContent || 'center' : justifyContent
  };
};
/**
 * @component
 */


var BoxStyled = (0, _theme.styled)('div')(getStyles, _marginPadding.marginPaddingStyles);

var Box =
/*#__PURE__*/
function (_React$PureComponent) {
  (0, _inherits2.default)(Box, _React$PureComponent);

  function Box(props) {
    var _this;

    (0, _classCallCheck2.default)(this, Box);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(Box).call(this, props));
    _this.boxComponent = props.as ? BoxStyled.withComponent(props.as, {
      target: "e1jn640s0"
    }) : BoxStyled;
    return _this;
  }

  (0, _createClass2.default)(Box, [{
    key: "render",
    value: function render() {
      var Component = this.boxComponent;
      var _this$props = this.props,
          children = _this$props.children,
          innerRef = _this$props.innerRef,
          restProps = (0, _objectWithoutProperties2.default)(_this$props, ["children", "innerRef"]);
      return (0, _core.jsx)(Component, (0, _extends2.default)({
        ref: innerRef
      }, restProps), children);
    }
  }]);
  return Box;
}(_react.default.PureComponent);

Box.defaultProps = {
  boxSizing: 'border-box'
};
var _default = Box;
exports.default = _default;